import styled from 'styled-components/macro';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {useState} from "react";
import {useFeedback} from "../../../store/feedback";
import {useSaveRules} from "../../../api/moderation";

const EditRule = styled(({className, communityRules, setCommunityRules, community, i, onClose}) => {
    const {feedbackCh} = useFeedback();
    const saveRules = useSaveRules(feedbackCh);
    const [rules, setRules] = useState(communityRules);
    const [rule, setRule] = useState(rules[i] || '');
    const [saving, setSaving] = useState(false);
    const handleSave = async (type) => {
        setSaving(true);
        const r = [... rules];
        let updated;
        if (i === -1) {
            // add new
            updated = [...r, rule];
        } else if (type === 'delete') {
            // delete
            updated = r.filter((_, index) => index != i);
        } else {
            // replace
            r[i] = rule;
            updated = r;
        }
        // save to API
        await saveRules(JSON.stringify(updated), community);
        setCommunityRules(updated);
        setSaving(false);
        onClose();
    }
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{i === -1 ? 'Add' : 'Edit'} Rule</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                        <Input placeholder="No cats allowed." value={rule} maxLength={64} autoComplete={"off"}
                               onChange={(e) => setRule(e.currentTarget.value)} required />
                </ModalBody>
                <ModalFooter>
                    {i !== -1 &&
                        <Button variant="cancel" mr={3} onClick={() => handleSave('delete')}>Delete</Button>
                    }
                    <Button variant="blue" onClick={() => handleSave('update')} isLoading={saving}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default EditRule;
